export default "__VITE_ASSET__jUo2G9t5__"